import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-admin',
    template:
        '<app-header></app-header><app-agent-sidebar></app-agent-sidebar><router-outlet></router-outlet>'
})
export class AgentComponent implements OnInit {
    public section: String;

    constructor(private activatedRoute: ActivatedRoute) {
        this.activatedRoute.url.subscribe(url => {
            this.section = url[0].path;
        });
    }

    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/agent/agent.component.ts